
import firebase from 'firebase';
// actors

// const firebaseConfig = {
//   apiKey: "AIzaSyCwbKciY3q7kaj7-s8FFF0p2ymSjD5TsVY",
//   authDomain: "generator-komedii.firebaseapp.com",
//   databaseURL: "https://generator-komedii-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "generator-komedii",
//   storageBucket: "generator-komedii.appspot.com",
//   messagingSenderId: "393706872667",
//   appId: "1:393706872667:web:aea33de24d436506c5047e"
// };
const firebaseConfig = {
  apiKey: "AIzaSyDj7UV4FnQUcSWFqIf0VeFYXy0EHQjhFjs",
  authDomain: "linkedin-trening.firebaseapp.com",
  projectId: "linkedin-trening",
  storageBucket: "linkedin-trening.appspot.com",
  messagingSenderId: "803738161141",
  appId: "1:803738161141:web:9466a722494f7a03d6dabc"
};
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  
  const db = firebaseApp.firestore();
  

  export {db};
  export default firebase;


  // posts
  // const firebaseConfig = {
  //   apiKey: "AIzaSyDj7UV4FnQUcSWFqIf0VeFYXy0EHQjhFjs",
  //   authDomain: "linkedin-trening.firebaseapp.com",
  //   projectId: "linkedin-trening",
  //   storageBucket: "linkedin-trening.appspot.com",
  //   messagingSenderId: "803738161141",
  //   appId: "1:803738161141:web:9466a722494f7a03d6dabc"
  // };